<div
  class="rounded-xl border border-neutral-300 w-full py-4 px-3 bg-neutral-50 text-start flex gap-x-3 items-center justify-between"
>
  <p class="text-xs font-semibold">{{ label }}</p>
  <mat-slide-toggle [formControl]="control" [hideIcon]="true" ctrColorSlideToggle></mat-slide-toggle>
</div>
